import { render } from "./lhbdDetail.vue?vue&type=template&id=b2ea22aa&scoped=true&ts=true"
import script from "./lhbdDetail.vue?vue&type=script&lang=ts"
export * from "./lhbdDetail.vue?vue&type=script&lang=ts"

import "./lhbdDetail.vue?vue&type=style&index=0&id=b2ea22aa&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ea22aa"]])

export default __exports__